import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import Collapse from '@material-ui/core/Collapse';

import SecondaryNav from './SecondaryNav';
import { isPermissible } from '../Global/PermissionResolver';

export class PrimaryNav extends Component {
  state = {
    subMenuIdOpened: null,
    subMenuIdSelected: null
  };

  _handleToggleSubMenu = subMenuId => {
    const { subMenuIdOpened } = this.state;
    this.setState({
      subMenuIdOpened: subMenuIdOpened === subMenuId ? null : subMenuId
    });
  };

  _handleSubMenuIdSelected = subMenuId => {
    this.setState({
      subMenuIdSelected: subMenuId
    });
  };

  render() {
    const {
      links,
      classes,
      t,
      open,
      currentPath,
      currentOrgId,
      globalProps
    } = this.props;
    return (
      <List className={classes.primaryNavRoot}>
        {links
          .filter(
            link =>
              !link.parent &&
              (!link.requiresOrg || (link.requiresOrg && currentOrgId)) &&
              link.isPermitted(globalProps, isPermissible)
          )
          .map(link => {
            const nestedLinks = links.filter(
              nestedLink => nestedLink.parent === link.groupId
            );
            return (
              <Fragment key={link.name}>
                <ListItem
                  button
                  component={NavLink}
                  to={link.path || '#'}
                  selected={link.path === currentPath}
                  activeClassName={
                    link.groupId
                      ? classes.groupExpanded
                      : classes.primaryMenuActive
                  }
                  classes={{
                    button: classNames(classes.menuDefaultColor),
                    root: classNames(classes.menuRow, {
                      [classes.groupExpanded]:
                        link.groupId &&
                        (this.state.subMenuIdOpened === link.groupId ||
                          this.state.subMenuIdSelected === link.groupId)
                    })
                  }}
                  onClick={() => this._handleToggleSubMenu(link.groupId)}
                  isActive={(_match, location) => {
                    if (link.groupId) {
                      return (
                        nestedLinks
                          .map(nestedLinkItem => nestedLinkItem.path)
                          .indexOf(location.pathname) >= 0
                      );
                    }

                    return link.path === location.pathname;
                  }}
                >
                  <ListItemIcon
                    className={classNames(
                      'menuIcon',
                      classes.menuDefaultColor,
                      classes.menuIcon
                    )}
                  >
                    {link.icon && <link.icon />}
                  </ListItemIcon>
                  {open && (
                    <ListItemText
                      primary={t(link.name)}
                      classes={{
                        primary: classNames(
                          classes.menuText,
                          classes.menuDefaultColor,
                          'menuText'
                        ),
                        root: classNames(
                          classes.primaryMenuText,
                          classes.menuDefaultColor
                        )
                      }}
                    />
                  )}
                </ListItem>
                {open && link.groupId && (
                  <Collapse
                    in={this.state.subMenuIdOpened === link.groupId}
                    timeout="auto"
                    unmountOnExit
                  >
                    {nestedLinks
                      .filter(nestedLink =>
                        nestedLink.isPermitted(globalProps, isPermissible)
                      )
                      .map(nestedLink => (
                        <SecondaryNav
                          classes={classes}
                          link={nestedLink}
                          key={nestedLink.name}
                          onClick={this._handleSubMenuIdSelected}
                          currentPath={currentPath}
                        />
                      ))}
                  </Collapse>
                )}
              </Fragment>
            );
          })}
      </List>
    );
  }
}

PrimaryNav.propTypes = {
  classes: PropTypes.object.isRequired,
  links: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default withNamespaces()(PrimaryNav);
